var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-col',{staticClass:"pt-0 pl-0",attrs:{"id":"bubble-chart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }